/* tslint:disable */
/* eslint-disable */
/**
 * Application
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddNewGiftCardRequest } from '../model';
// @ts-ignore
import { ApiErrorResponse } from '../model';
// @ts-ignore
import { UserGiftCardsResponse } from '../model';
/**
 * GiftCardApiApiGiftCardAddNewGiftCardsByCountGet - axios parameter creator
 * 
 * @param {number} [count] 
 * @param {number} [giftCardGroupId] 
 * @param {number} [amount] 
 * @param {string} [expDate] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardApiApiGiftCardAddNewGiftCardsByCountGetAxiosParamCreator (count?: number, giftCardGroupId?: number, amount?: number, expDate?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCard/AddNewGiftCardsByCount`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (count !== undefined) {
        localVarQueryParameter['count'] = count;
    }

    if (giftCardGroupId !== undefined) {
        localVarQueryParameter['giftCardGroupId'] = giftCardGroupId;
    }

    if (amount !== undefined) {
        localVarQueryParameter['amount'] = amount;
    }

    if (expDate !== undefined) {
        localVarQueryParameter['expDate'] = (expDate as any instanceof Date) ?
            (expDate as any).toISOString() :
            expDate;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPost - axios parameter creator
 * 
 * @param {AddNewGiftCardRequest} [addNewGiftCardRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPostAxiosParamCreator (addNewGiftCardRequest?: AddNewGiftCardRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCard/AddNewGiftCardsByPhoneNumber`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addNewGiftCardRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardApiApiGiftCardRenewSuspendTimeGet - axios parameter creator
 * 
 * @param {string} [giftCardCode] 
 * @param {number} [giftCardGroupId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardApiApiGiftCardRenewSuspendTimeGetAxiosParamCreator (giftCardCode?: string, giftCardGroupId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCard/RenewSuspendTime`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (giftCardCode !== undefined) {
        localVarQueryParameter['giftCardCode'] = giftCardCode;
    }

    if (giftCardGroupId !== undefined) {
        localVarQueryParameter['giftCardGroupId'] = giftCardGroupId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardApiApiGiftCardUserGiftCardsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardApiApiGiftCardUserGiftCardsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCard/UserGiftCards`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGiftCardAddNewGiftCardsByCountGet operation in GiftCardApi.
 * @export
 * @interface GiftCardApiApiGiftCardAddNewGiftCardsByCountGetRequest
 */
export interface GiftCardApiApiGiftCardAddNewGiftCardsByCountGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GiftCardApiApiGiftCardAddNewGiftCardsByCountGet
     */
    readonly count?: number

    /**
     * 
     * @type {number}
     * @memberof GiftCardApiApiGiftCardAddNewGiftCardsByCountGet
     */
    readonly giftCardGroupId?: number

    /**
     * 
     * @type {number}
     * @memberof GiftCardApiApiGiftCardAddNewGiftCardsByCountGet
     */
    readonly amount?: number

    /**
     * 
     * @type {string}
     * @memberof GiftCardApiApiGiftCardAddNewGiftCardsByCountGet
     */
    readonly expDate?: string
}

/**
 * Request parameters for apiGiftCardAddNewGiftCardsByPhoneNumberPost operation in GiftCardApi.
 * @export
 * @interface GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPostRequest
 */
export interface GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPostRequest {
    /**
     * 
     * @type {AddNewGiftCardRequest}
     * @memberof GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPost
     */
    readonly addNewGiftCardRequest?: AddNewGiftCardRequest
}

/**
 * Request parameters for apiGiftCardRenewSuspendTimeGet operation in GiftCardApi.
 * @export
 * @interface GiftCardApiApiGiftCardRenewSuspendTimeGetRequest
 */
export interface GiftCardApiApiGiftCardRenewSuspendTimeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GiftCardApiApiGiftCardRenewSuspendTimeGet
     */
    readonly giftCardCode?: string

    /**
     * 
     * @type {number}
     * @memberof GiftCardApiApiGiftCardRenewSuspendTimeGet
     */
    readonly giftCardGroupId?: number
}

/**
* 
* @param {GiftCardApiApiGiftCardAddNewGiftCardsByCountGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardApiApiGiftCardAddNewGiftCardsByCountGet(requestParameters: GiftCardApiApiGiftCardAddNewGiftCardsByCountGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardApiApiGiftCardAddNewGiftCardsByCountGetAxiosParamCreator(requestParameters.count, requestParameters.giftCardGroupId, requestParameters.amount, requestParameters.expDate, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPost(requestParameters: GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardApiApiGiftCardAddNewGiftCardsByPhoneNumberPostAxiosParamCreator(requestParameters.addNewGiftCardRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardApiApiGiftCardRenewSuspendTimeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardApiApiGiftCardRenewSuspendTimeGet(requestParameters: GiftCardApiApiGiftCardRenewSuspendTimeGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardApiApiGiftCardRenewSuspendTimeGetAxiosParamCreator(requestParameters.giftCardCode, requestParameters.giftCardGroupId, options, configuration);
    const request: () => AxiosPromise<Array<UserGiftCardsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardApiApiGiftCardUserGiftCardsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardApiApiGiftCardUserGiftCardsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<UserGiftCardsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
